import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToolService, ToastService } from 'src/app/services';
import { NgxPowerBiService } from 'ngx-powerbi';
import { Report, models } from 'powerbi-client';

@Component({
    selector: 'app-power-bi',
    templateUrl: './power-bi.component.html',
    styleUrls: ['./power-bi.component.scss'],
    standalone: false
})
export class PowerBiComponent implements OnInit {

  @Input() idExecution: string;
  @Input() show_scrollbar : boolean = true;

  @Output() getReport : EventEmitter<Report> = new EventEmitter<Report>(); 

  token: string;
  reportId: string;
  private report : Report;
  pbiContainerElement: HTMLElement;

  constructor(
    private toolService: ToolService,
    private toastService: ToastService,
    private powerBiService: NgxPowerBiService
  ) {
    this.powerBiService = new NgxPowerBiService();
  }

  /**
   * Save the token for power BI, set the properties for the power BI dashboard
   */

  async ngOnInit() {
    try {
      const {token, report_id} = await this.toolService.getPowerBiToken(this.idExecution);
      this.token = token;
      this.reportId = report_id;

      this.pbiContainerElement = document.getElementById('pbi-container');
      const config = {
        type: 'report',
        id: this.reportId,
        embedUrl:
          'https://app.powerbi.com/reportEmbed?' +
          `reportId=${this.reportId}` +
          '&groupId=2064ca02-e68f-4abb-ac8d-81d27841860f',
        accessToken: this.token,
        tokenType: models.TokenType.Embed,
        settings: {
          filterPaneEnabled: false
        },
        // TODO Capire se serve o meno
        /* permissions: models.Permissions.All,
        viewMode: models.ViewMode.Edit, */
      };

      this.report = this.powerBiService.embed(this.pbiContainerElement, config)  as Report;
      this.getReport.emit(this.report)
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  public async refreshReport(){
    //get a new accees token, reset filter, set new token and the reload with new parameters
    const {token, report_id} = await this.toolService.getPowerBiToken(this.idExecution);
    this.report.reload();
    this.report.setAccessToken(token);
    this.report.refresh();
  }
}
